import { render, staticRenderFns } from "./InviteToListMenuItem.vue?vue&type=template&id=5d501994&scoped=true&"
import script from "./InviteToListMenuItem.vue?vue&type=script&lang=js&"
export * from "./InviteToListMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d501994",
  null
  
)

export default component.exports